module.exports = __webpack_public_path__ + "img/7ed8180.png";